import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetAccountInfoForWorkspacesQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
}>;


export type GetAccountInfoForWorkspacesQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, displayName?: string | null, tier?: Types.AccountTier | null, image?: { __typename?: 'Images', image128?: string | null } | null, permissions?: { __typename?: 'AccountPermissions', canCreateWorkspace: boolean } | null, viewerAccountData?: { __typename?: 'UserAccountData', canCreateWorkspace: boolean } | null } | null };


export const GetAccountInfoForWorkspaces = /*#__PURE__*/ gql`
    query GetAccountInfoForWorkspaces($accountId: ID!) {
  account(accountId: $accountId) {
    id
    displayName
    tier
    image {
      image128
    }
    permissions {
      canCreateWorkspace
    }
    viewerAccountData {
      canCreateWorkspace
    }
  }
}
    ` as unknown as DocumentNode<GetAccountInfoForWorkspacesQuery, GetAccountInfoForWorkspacesQueryVariables>;

          

          export const useGetAccountInfoForWorkspacesQuery = (options?:QueryHookOptions<GetAccountInfoForWorkspacesQuery, GetAccountInfoForWorkspacesQueryVariables>) => useQuery(GetAccountInfoForWorkspaces, options);

          

          export type GetAccountInfoForWorkspacesQueryOptions = QueryHookOptions<GetAccountInfoForWorkspacesQuery, GetAccountInfoForWorkspacesQueryVariables>;

          

          export const useGetAccountInfoForWorkspacesLazyQuery = (options?:LazyQueryHookOptions<GetAccountInfoForWorkspacesQuery, GetAccountInfoForWorkspacesQueryVariables>) => useLazyQuery(GetAccountInfoForWorkspaces, options);

          

          export type GetAccountInfoForWorkspacesQueryResult = ReturnType<typeof useGetAccountInfoForWorkspacesQuery>;

          
